import { useState } from 'react';
import { Button, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import styled from 'styled-components';
import { MULTI_YEAR, N_YEARS } from '../constants/years';
import { useYearsArray } from '../utils/hooks';
import { FilterButton } from './FilterDropdown';
import ChevronIcon from './icons/ChevronIcon';

const YearsGrid = styled.div`
  columns: 75px 3;
  width: 250px;
  text-align: center;
  column-gap: 0;
  button {
    will-change: transform;
  }
`;

const BlueButton = styled(Button)`
  color: #0091ff;
`;

const MULTI_YEAR_LABEL = 'Filter year';

export const YearPopover = ({ onChange, target, allYears }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const toggleButtonSelect = () => setPopoverOpen(false);

  return (
    <Popover
      placement="bottom"
      isOpen={popoverOpen}
      target={target}
      toggle={toggle}
      trigger="legacy"
      hideArrow
    >
      <PopoverHeader className="text-center">Select Year</PopoverHeader>
      <PopoverBody>
        <YearsGrid>
          {allYears.map((y, i) => (
            <BlueButton
              key={y}
              onClick={() => {
                onChange(i);
                toggleButtonSelect();
              }}
              color="link"
            >
              {y}
            </BlueButton>
          ))}
        </YearsGrid>
      </PopoverBody>
    </Popover>
  );
};

const YearSelect = ({
  yearIndex,
  className,
  filterStyles = true,
  startYear,
  ...popoverProps
}) => {
  const allYears = useYearsArray(N_YEARS, startYear);
  return (
    <div>
      <FilterButton
        size="sm"
        id="year-select"
        className={className}
        filterStyles={filterStyles}
        selected={yearIndex !== MULTI_YEAR}
      >
        {allYears[yearIndex] || MULTI_YEAR_LABEL}
        <ChevronIcon />
      </FilterButton>
      <YearPopover target="year-select" allYears={allYears} {...popoverProps} />
    </div>
  );
};

export default YearSelect;
